<template>
    <md-list class="md-dense">
        <md-list-item v-for="contact in contacts" :key="contact.id" class="mb-1">
            <div class="md-list-item-text flex-row items-center justify-between">
                <span class="w-auto">{{ contact.full_name }}</span>
                <div class="w-auto flex items-center divide-x-2 divide-gray-300">
                    <div class="w-auto pr-2">
                        <span>{{ contact.phone }}</span>
                    </div>
                    <div class="w-auto pl-2">
                        <md-button class="md-icon-button md-raised md-info" :href="'mailto:' + contact.email">
                            <i class="md-icon fa fa-envelope" />
                        </md-button>
                        <md-tooltip md-direction="top">{{ contact.email }}</md-tooltip>
                    </div>
                </div>
            </div>
        </md-list-item>
    </md-list>
</template>

<script>
export default {
    name: "ClientContactsSelected",
    props: {
        contacts: Array
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-list-item {
        .md-list-item-container {
            .md-list-item-content {
                padding: 0;
                min-height: 15px;
                .md-list-item-text {
                    position: relative;
                    font-size: .75rem;
                }
                .md-button {
                    width: auto;
                    .md-ripple {
                        padding: 0 8px;
                    }
                }
                .md-icon {
                    font-size: 0.875rem !important;
                    min-width: 0.875rem !important;
                    height: 0.875rem !important;
                }
            }
        }
    }
    .md-icon-button {
        margin: 0;
        padding: 5px;
        height: 27px;
        min-width: 35px;
        width: auto;
        line-height: 27px;
        .md-icon {
            font-size: 0.875rem !important;
            min-width: 0.875rem !important;
            height: 0.875rem !important;
        }
    }
}
</style>
